export const cn = {
    currentPlan: '当前方案',
    month: '月',
    year: '年',
    billingCycle: {
        monthly: '月付',
        yearly: '年付',
        saveAmount: '节省{amount}',
    },
    recommend: '最受欢迎',
    subscriptionExists: '您已经有一个有效的订阅',
    plans: {
        basic: {
            name: '基础版',
            price: '免费',
            description: '适合验证研究假设或体验平台的个人用户',
            featuresHeader: '方案功能:',
            features: {
                0: '生命科学领域专属 Hiro 科研问答',
                1: '文档精读专利、文献、会议海报对比分析（每次至多上传2个文件）',
                2: '体验 Lead化合物分析及 SAR 数据提取（仅限5次）',
                3: '2份AI驱动情报简报，提前捕捉市场信号',
            },
        },
        pro: {
            name: '专业版',
            description: '为科研工作者提供完整的研究能力',
            buttonText: '升级',
            featureGroupHeader: '包含基础版全部功能，以及：',
            featureGroups: [
                {
                    features: {
                        0: '每日使用额度最高提升7.5倍',
                        2: '文档精读功能扩展（每次至多上传5个文件）',
                        3: 'Lead化合物分析开放导出（每月5次）',
                        4: '5份AI驱动情报简报（每周更新）',
                    },
                }
            ],
        },
        enterprise: {
            name: '企业版',
            description: '赋能全团队的科研发现',
            buttonText: '预约演示',
            price: '联系我们',
            featureGroupHeader: '包含专业版全部功能，以及：',
            featureGroups: [
                {
                    header: '深度科研',
                    features: {
                        0: 'SAR提取即将上线',
                        1: '结构到马库什智能体的关联通路',
                    },
                },
                {
                    header: '能力扩展',
                    features: {
                        0: '更高用量配额与更高性能模型',
                        1: '内置科研记录系统',
                        2: '全格式文件导出（FASTA、SDF、SMILES）',
                        3: '额外专家智能体（知产报告、抗体抗原筛选、马库什撰写）',
                    },
                },
                {
                    header: '安全与管控',
                    features: {
                        0: '共享项目',
                        1: '团队协作',
                        2: '企业级安全与SSO及管理员控制',
                        3: '专属客户支持',
                    },
                }
            ],
        },
        api: {
            name: 'API',
            description: '让智能体融入您的研究工作流',
            buttonText: '了解更多',
            price: '定制化报价',
            featuresHeader: '包含专业版,以及:',
            features: {
                0: '即插即用部署，按用量灵活计费',
                1: '通过API、组件和连接器直接嵌入现有工作流',
                2: '借助 Agent Skills 与 MCP 大幅提升智能体能力',
                3: '从底层构建企业级安全架构',
            },
        },
    },
}

export const en = {
    currentPlan: 'Current Plan',
    month: 'month',
    year: 'year',
    billingCycle: {
        monthly: 'Monthly',
        yearly: 'Yearly',
        saveAmount: 'Save {amount}',
    },
    recommend: 'MOST POPULAR',
    subscriptionExists: 'You already have an active subscription',
    plans: {
        basic: {
            name: 'Basic',
            description: 'Ideal for individuals validating a hypothesis or testing the platform',
            featuresHeader: 'Plan Features:',
            price: 'Free',
            features: {
                0: 'Domain-specific Hiro research Q&A​',
                1: 'Document analysis for patent, literature, conference posters comparison (2 files/upload)​',
                2: 'Try lead compound analysis with SAR data extraction (5 times only)​',
                3: '2 AI-enabled Pulse briefs to spot market signals early',
            },
        },
        pro: {
            name: 'Pro',
            description: 'Full research capabilities for working scientists',
            buttonText: 'Upgrade',
            featureGroupHeader: 'Everything in Basic, plus:',
            featureGroups: [
                {
                    features: {
                        0: 'Up to 7.5X higher daily usage limit',
                        2: 'Expanded functionalities for Document Analysis (5 files/upload)​',
                        3: 'Export enabled for Lead Compound Analysis (5/month)​',
                        4: '5 Weekly AI-enabled Pulse Briefings',
                    },
                }
            ],
        },
        enterprise: {
            name: 'Enterprise',
            description: 'Scale discovery across your whole team',
            buttonText: 'Book a Demo',
            price: 'Contact us',
            featureGroupHeader: 'Everything in pro, plus:',
            featureGroups: [
                {
                    header: 'Deep Science​',
                    features: {
                        0: 'SAR extraction​ coming soon​​',
                        1: 'Connection from Structures to Markush agent​​',
                    },
                },
                {
                    header: 'Expanded Capabilities​',
                    features: {
                        0: 'Increased usage with higher-tier model performance​',
                        1: 'Built-in system of record​',
                        2: 'Full file exports (FASTA, SDF,SMILES)​',
                        3: 'Additional expert AI agents (Antibody Target Predictor, Markush Claim Drafting, Pharma CI Explorer))​',
                    },
                },
                {
                    header: 'Security & Control',
                    features: {
                        0: 'Shared projects​',
                        1: 'Team collaboration​',
                        2: 'Enterprise security with SSO and admin controls​',
                        3: 'Dedicated Customer Support',
                    },
                }
            ],
        },
        api: {
            name: 'API',
            description: 'Embed agents into your research infrastructure',
            buttonText: 'Learn more',
            price: 'Custom',
            featuresHeader: 'Includes Pro, plus:',
            features: {
                0: 'Plug-and-play deployment with flexible, usage-based pricing',
                1: 'Embed directly into your existing workflows through APIs, widgets, and connectors',
                2: 'Supercharge agent performance with Agent Skills and MCPs',
                3: 'Built with enterprise-grade security at its core',
            },
        },
    },
}

export const tw = {
    currentPlan: '目前方案',
    month: '月',
    year: '年',
    billingCycle: {
        monthly: '月付',
        yearly: '年付',
        saveAmount: '節省{amount}',
    },
    recommend: '最受歡迎',
    subscriptionExists: '您已經有一個有效的訂閱',
    plans: {
        basic: {
            name: '基礎版',
            price: '免費',
            description: '適合驗證研究假設或體驗平台的個人用戶',
            featuresHeader: '方案功能:',
            features: {
                0: '生命科學領域專屬 Hiro 科研問答',
                1: '文檔精讀專利、文獻、會議海報對比分析（每次至多上傳2個檔案）',
                2: '體驗 Lead化合物分析及 SAR 數據提取（僅限5次）',
                3: '2份AI驅動情報簡報，提前捕捉市場訊號',
            },
        },
        pro: {
            name: '專業版',
            description: '為科研工作者提供完整的研究能力',
            buttonText: '升級',
            featureGroupHeader: '包含基礎版全部功能，以及：',
            featureGroups: [
                {
                    features: {
                        0: '每日使用額度最高提升7.5倍',
                        2: '文檔精讀功能擴展（每次至多上傳5個檔案）',
                        3: 'Lead化合物分析開放導出（每月5次）',
                        4: '5份AI驅動情報簡報（每週更新）',
                    },
                }
            ],
        },
        enterprise: {
            name: '企業版',
            description: '賦能全團隊的科研發現',
            buttonText: '預約示範',
            price: '聯繫我們',
            featureGroupHeader: '包含專業版全部功能，以及：',
            featureGroups: [
                {
                    header: '深度科研',
                    features: {
                        0: 'SAR提取即將上線',
                        1: '結構到馬庫什智能體的關聯通路',
                    },
                },
                {
                    header: '能力擴展',
                    features: {
                        0: '更高用量配額與更高效能模型',
                        1: '內建科研記錄系統',
                        2: '全格式檔案導出（FASTA、SDF、SMILES）',
                        3: '額外專家智能體（知產報告、抗體抗原篩選、馬庫什撰寫）',
                    },
                },
                {
                    header: '安全與管控',
                    features: {
                        0: '共享項目',
                        1: '團隊協作',
                        2: '企業級安全與SSO及管理員控制',
                        3: '專屬客戶支持',
                    },
                }
            ],
        },
        api: {
            name: 'API',
            description: '讓智能體融入您的研究工作流',
            buttonText: '了解更多',
            price: '客製化報價',
            featuresHeader: '包含專業版,以及:',
            features: {
                0: '即插即用部署，按用量靈活計費',
                1: '透過API、元件和連接器直接嵌入現有工作流',
                2: '藉助Agent Skills與MCP大幅提升智能體能力',
                3: '從底層構建企業級安全架構',
            },
        },
    },
}

export const jp = {
    currentPlan: '現在のプラン',
    month: '月',
    year: '年',
    billingCycle: {
        monthly: '月払い',
        yearly: '年払い',
        saveAmount: '{amount} お得',
    },
    recommend: '最も人気',
    subscriptionExists: '既にアクティブなサブスクリプションがあります',
    plans: {
        basic: {
            name: 'ベーシック',
            price: '無料',
            description: '仮説検証やプラットフォーム体験に最適な個人向けプラン',
            featuresHeader: 'プラン機能:',
            features: {
                0: 'ライフサイエンス領域特化の Hiro リサーチQ&A',
                1: 'ドキュメント精読で特許・文献・学会ポスターを比較分析（1回最大2ファイル）',
                2: 'Lead化合物分析 & SARデータ抽出を体験（5回限定）',
                3: '2件のAI駆動インテリジェンスブリーフ、市場シグナルをいち早くキャッチ',
            },
        },
        pro: {
            name: 'プロ',
            description: '研究者のための本格的なリサーチ機能',
            buttonText: 'アップグレード',
            featureGroupHeader: 'ベーシックの全機能に加えて：',
            featureGroups: [
                {
                    features: {
                        0: '1日あたりの利用枠が最大7.5倍に拡大',
                        2: 'ドキュメント精読機能を拡張（1回最大5ファイル）',
                        3: 'Lead化合物分析のエクスポート機能を開放（月5回）',
                        4: '5件のAI駆動インテリジェンスブリーフ（毎週更新）',
                    },
                }
            ],
        },
        enterprise: {
            name: 'エンタープライズ',
            description: 'チーム全体の創薬ディスカバリーを加速',
            buttonText: 'デモを予約',
            price: 'お問い合わせ',
            featureGroupHeader: 'プロの全機能に加えて：',
            featureGroups: [
                {
                    header: 'ディープサイエンス',
                    features: {
                        0: 'SAR抽出近日公開',
                        1: '構造からマーカッシュエージェントへの連携パス',
                    },
                },
                {
                    header: '能力拡張',
                    features: {
                        0: 'より多い利用枠と高性能モデル',
                        1: '内蔵の研究記録システム',
                        2: '全フォーマットファイルエクスポート（FASTA、SDF、SMILES）',
                        3: '追加エキスパートエージェント（知財レポート、抗体抗原スクリーニング、マーカッシュ起草）',
                    },
                },
                {
                    header: 'セキュリティと管理',
                    features: {
                        0: '共有プロジェクト',
                        1: 'チームコラボレーション',
                        2: 'SSOおよび管理者コントロールを備えたエンタープライズセキュリティ',
                        3: '専任カスタマーサポート',
                    },
                }
            ],
        },
        api: {
            name: 'API',
            description: 'エージェントを研究ワークフローに統合',
            buttonText: '詳細を見る',
            price: 'カスタム見積もり',
            featuresHeader: 'プロ版に加えて:',
            features: {
                0: 'プラグアンドプレイで導入、従量課金で柔軟に運用',
                1: 'API・ウィジェット・コネクタで既存ワークフローに直接組み込み',
                2: 'Agent SkillsとMCPでエージェント性能を大幅強化',
                3: 'エンタープライズグレードのセキュリティを基盤から構築',
            },
        },
    },
}
